var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    rx: 72,
    fill: "url(#paint0_linear_3433_16698)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5 65C62.232 65 68.5 58.732 68.5 51C68.5 43.268 62.232 37 54.5 37C46.768 37 40.5 43.268 40.5 51C40.5 58.732 46.768 65 54.5 65ZM89.5 72C97.232 72 103.5 65.732 103.5 58C103.5 50.268 97.232 44 89.5 44C81.768 44 75.5 50.268 75.5 58C75.5 65.732 81.768 72 89.5 72ZM110.5 96.5C110.5 91.25 105.25 79 91.25 79C79 79 75.5 91.25 75.5 96.5C75.5 101.75 77.25 103.5 82.4999 103.5H103.5C108.75 103.5 110.5 101.75 110.5 96.5ZM52.7502 72C65.0002 72 68.5002 87.75 68.5002 94.75L68.5002 96.5C68.5002 101.75 66.7502 103.5 61.5001 103.5H40.5001C35.2502 103.5 33.5002 101.75 33.5002 96.5L33.5 94.75C33.5 86 38.75 72 52.7502 72Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3433_16698",
    x1: 144,
    y1: 144,
    x2: 6.85937,
    y2: -6.26045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4830BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A455F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.afcb3630.svg";
export { ForwardRef as ReactComponent };